var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlzLogoBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 69,
    viewBox: "0 0 36 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_20685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7903 29.9971H48.2068L57.2063 60.4123H54.2898L51.8733 51.5794H41.2071L38.7905 60.4123H35.874L44.7903 29.9971ZM51.2899 49.3295L46.6235 32.247H46.5402L41.8737 49.3295H51.2899Z",
    fill: "#6AA025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3754 28.7477C14.4585 12.6651 10.2088 0.499023 10.2088 0.499023C10.2088 0.499023 21.1249 15.415 15.6252 34.8307C10.5421 52.5799 14.2086 63.3293 14.2086 63.3293C14.2086 63.3293 4.3757 52.7465 10.3754 28.7477Z",
    fill: "#6AA025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7919 48.4131C19.9584 40.4135 28.2913 39.8302 32.8744 22.0811C32.8744 22.0811 32.8744 22.0811 32.9578 22.0811C33.6244 43.33 27.708 47.0799 22.5416 52.3296C18.5418 56.3294 16.5419 60.7459 15.7919 62.8291C14.9586 65.079 15.6253 59.9959 16.1252 57.746C19.8751 43.33 29.7079 45.7466 31.8745 28.6641C31.9578 27.9974 32.0411 27.4141 32.1245 26.7475C32.0411 27.4975 31.9578 27.9974 31.8745 28.6641C28.2913 47.7465 16.7919 40.9968 14.1253 62.8291C14.042 65.7456 12.4587 54.9128 15.7919 48.4131Z",
    fill: "#135629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_20685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 69,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlzLogoBig);
export default __webpack_public_path__ + "static/media/AlzLogoBig.c20152e5064f2d1056694b11452301a1.svg";
export { ForwardRef as ReactComponent };